import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { CenterDto } from "@malirang/api-client";
import { ActionSheetHeader, ModalAdapter } from "@malirang/front-share";
import { SelectCenterContentComponent } from "apps/client/src/app/layout/components/select-center/content/select-center-content.component";
import { CenterStore } from "apps/client/src/stores/center/center.store";

@Component({
    selector: "app-select-center-modal",
    templateUrl: "./select-center.modal.html",
    imports: [CommonModule, ActionSheetHeader, SelectCenterContentComponent],
})
export class SelectCenterModal extends ModalAdapter {
    readonly centerStore = inject(CenterStore);

    currentCenter = this.centerStore.currentCenter;

    selectCenter(center: CenterDto) {
        this.centerStore.setCurrentCenter(center);
        this.close();
    }
}
